'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Picker = require('./Picker.web');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Picker)["default"];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-picker/lib/index.web.js
 ** module id = 436
 ** module chunks = 0
 **/